export * from "./BankDetails";
export * from "./NewSubscriber";
export * from "./NomineeDetails";
export * from "./PersonalDetails";
export * from "./NpsSchemeDetails";
export * from "./UploadDocuments";

export const SUCCESS_RESPONSE_CODE = 10000;

export const INVESTMENT_OPTIONS = [
  { label: "Active", value: "1" },
  { label: "Auto", value: "2" },
];

export const FUND_OPTIONS = {
  E: "Equity",
  C: "Corporate Bonds",
  G: "Government Securites",
  A: "Alternate Investment Funds",
};

export const PENSION_FUND_OPTIONS = [
  {
    value: 110,
    label: "Aditya Birla Sun Life Pension Management Limited",
  },
  {
    value: 108,
    label: "HDFC Pension Management Company Limited",
  },
  {
    value: 107,
    label: "ICICI Prudential Pension Funds Management Company Limited",
  },
  {
    value: 105,
    label: "Kotak Mahindra Pension Fund Limited",
  },
  {
    value: 103,
    label: "LIC Pension Fund Limited",
  },
  {
    value: 101,
    label: "SBI Pension Funds Private Limited",
  },
  {
    value: 102,
    label: "UTI Retirement Solutions Limited",
  },
];

export const FREQUENCY = [
  {
    value: 1,
    label: "MONTHLY",
  },
  {
    value: 2,
    label: "YEARLY",
  },
  {
    value: 3,
    label: "WEEKLY",
  },
];
